module.exports = __webpack_public_path__ + "static/media/message-circle_gray.36f1019e.svg";